import { Box } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import Breadcrumbs from "../../../../src/components/common/Breadcrumbs";
import { SecondaryHeader } from "../../../../src/components/common";
import PricingSelectCityModal from "../../../../src/components/PricingPage/PricingSelectCityModal";
import LoanFormPopupV2 from "../../../../src/Drawer/LoanFormPopupV2";
import FAQ from "../../../../src/SDK/FAQ/faq";
import TurnoPromiseComponent from "../../../../src/SDK/FAQ/turnoPromiseComponent";
import { vehicleFAQs } from "../../../../src/constants/brandFaqs";
import { newVehicles, vehicles } from "../../../../src/constants/vehicleData";
import { keySpecificationsInfo } from "../../../../src/constants/vehicleKeySpec";
import { vehiclePromiseList } from "../../../../src/constants/vehiclesPromises";
import { imagesWEBP } from "../../../../src/constants/webpImages";
import { Context } from "../../../../src/context/context";
import { MemoizedFooter } from "../../../../src/layouts/footer";
import { MemoizedHeader } from "../../../../src/layouts/header";
import NewVehicleReview from "../../../../src/modules/Home/BrandExp/NewVehicleReview";
import BookVehicleDrawer from "../../../../src/modules/Home/Drawer/bookVehicleDrawer";
import MemoizedKeySpecifications from "../../../../src/modules/Home/VehiclesV2/KeySpecifications";
import ProductTopBanner from "../../../../src/modules/Home/VehiclesV2/ProductTopBanner";
import MemoizedVehicleFeatures from "../../../../src/modules/Home/VehiclesV2/VehicleFeatures";
import VehicleLatestList from "../../../../src/modules/Home/VehiclesV2/VehicleLatestList";
import VehicleSpecificUseSwiper from "../../../../src/modules/Home/VehiclesV2/VehicleSpecificUses";
import WebShare from "../../../../src/modules/Lead Capture/WebShare.jsx/WebShare";
import HeaderDesc from "../../../../src/modules/Vehicles/Banner/HeaderDesc";
import MemoizedBrandDealerNear from "../../../../src/modules/Vehicles/BrandDealerNear";
import PricingPopularCities from "../../../../src/components/PricingPage/PricingPopularCities";
import { MemoizedLeadCaptureV2 } from "../../../../src/pages/LeadCapture/LeadCaptureV2";
import { sendAnalytics } from "../../../../src/utils/analyticsCommon";
import { useMobile } from "../../../../src/utils/findViewport";
import MemoizedSearchHeader from "../../../../src/modules/Vehicles/searchHeader.jsx";
import {
  generateProductSchema,
  createOffer,
  createBrand,
  createPropertyValue,
} from "../../../../src/utils/ProductSchemaGenerator.js";
import {
  generateFAQPageSchema,
  convertFAQsToQuestions,
} from "../../../../src/utils/FAQPageSchemaGenerator.js";
import {
  TITLE,
  META_CONTENT,
  VEHICLE_LINK,
  KEY_SPECIFICATION_HEADER,
  HIGHLIGHTS_HEADING,
  HIGHLIGHTS_DESCRIPTION,
  MOSTLY_BOUGHT_FOR_HEADING,
  BUSINESS_BENEFIT_HEADING,
  FEATURES_HEADING,
  BRAND_DEALER_HEADING,
  BRAND_DEALER_DESCRIPITION,
  FAQ_HEADING_TEXT,
  BREADCRUMB_ITEMS,
  BREADCRUMB_SCHEMA,
} from "../../../../src/constants/electricCommericalVehicle/Piaggio/eXtraFXMax.js";

const PRICE_CITIES = [
  "pune",
  "mumbai",
  "bangalore",
  "hyderabad",
  "chennai",
  "kolkata",
  "delhi-ncr",
  "jaipur",
  "lucknow",
  "ahmedabad",
  "indore",
];

export default function VehicleModelDetails({
  brand,
  vehicleModel,
  vehicleDataLocal,
  plusIcons,
  latestVehiclesInfo,
  productSchema,
  faqPageSchema,
}) {
  const noentryData = [
    {
      id: 1,
      imageName: imagesWEBP?.businessFXMax1,
    },
    {
      id: 2,
      imageName: imagesWEBP?.businessFXMax2,
    },
    {
      id: 3,
      imageName: imagesWEBP?.businessFXMax3,
    },
    {
      id: 4,
      imageName: imagesWEBP?.businessFXMax4,
    },
  ];

  const useCaseData = [
    {
      id: 1,
      imageName: imagesWEBP?.piaggioFxMaxusecase0,
    },
    {
      id: 2,
      imageName: imagesWEBP?.piaggioFxMaxusecase1,
    },
    {
      id: 3,
      imageName: imagesWEBP?.piaggioFxMaxusecase2,
    },
    {
      id: 3,
      imageName: imagesWEBP?.piaggioFxMaxusecase3,
    },
  ];

  const images = [
    {
      original: imagesWEBP?.rating1,
    },
    {
      original: imagesWEBP?.rating2,
    },
    {
      original: imagesWEBP?.rating3,
    },
    { original: imagesWEBP?.rating4 },
  ];

  const isMobile = useMobile();
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_commercial_vehicle_${brand}_${vehicleModel}` },
      "en"
    );
  }, [brand, vehicleModel]);

  const state = useContext(Context);
  const router = useRouter();
  const [priceCityModalOpen, setPriceCityModalOpen] = useState(false);
  const [activeSectionId, setActiveSectionId] = useState("section-header");
  let location =
    state?.selectedState === "Others" ? "India" : state?.selectedState;

  const handlePriceCitySelect = (citySlug) => {
    setPriceCityModalOpen(false);
    router.push(`/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max/price/${citySlug}`);
  };

  const secondaryHeaderItems = [
    { label: "Piaggio E-Xtra FX Max", sectionId: "section-header" },
    {
      label: "Price",
      sectionId: "section-price",
      onClick: () => setPriceCityModalOpen(true),
    },
    { label: "Specification", sectionId: "section-specification" },
    { label: "Summary", sectionId: "section-summary" },
  ];

  return (
    <>
      <Head>
        <title>{TITLE}</title>
        {META_CONTENT.map((meta, index) => (
          <meta
            key={index}
            {...(meta.name ? { name: meta.name } : { property: meta.property })}
            content={meta.content}
          />
        ))}
        <link rel="canonical" href={VEHICLE_LINK} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productSchema),
          }}
          defer
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqPageSchema),
          }}
          defer
        />
      </Head>
      <Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <MemoizedHeader scrollWithPage={true} />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <MemoizedSearchHeader isProductPage={true} />
      </Box>
      <SecondaryHeader
        items={secondaryHeaderItems}
        activeSectionId={activeSectionId}
        onActiveSectionChange={setActiveSectionId}
        scrollOffsetTop={56}
      />
      <PricingSelectCityModal
        isOpen={priceCityModalOpen}
        onClose={() => setPriceCityModalOpen(false)}
        currentCitySlug={null}
        availableCities={PRICE_CITIES}
        onSelectCity={handlePriceCitySelect}
      />
      {/* Main component */}
      {/* <Box id="section-header" sx={{ display: { xs: "none", md: "block" }, background: "#F3F3F4" }}>
        <ProductTopBanner
          location={location}
          vehicle_name={"Piaggio E-Xtra FX Max"}
        />
      </Box> */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "120",
            display: { xs: "block", md: "none" },
            width: "100%",
          }}
        >
          <WebShare vehicleData={vehicleDataLocal[0]} />
          <BookVehicleDrawer />
        </Box>
      </Box>
      <Box id="section-price">
        <MemoizedLeadCaptureV2 vehicleDataLocal={vehicleDataLocal} />
      </Box>

      {/* <HeaderDesc
        HeadingTag="h2"
        heading="Piaggio E-Xtra FX Max"
        subText="Piaggio  Treo  Zor electric auto has a clutchless automatic transmission, which gives you a noiseless and vibration-free drive. It comes with a lithium-ion battery that lasts more than 1.5 lakh km, the Nemo app for real-time performance tracking, and a range of variants to suit all your needs. Priced between X and X lakhs, this electric cargo three-wheeler will keep you on the go. Here are a few more reasons why you should get this electric three-wheeler tempo:
"
      /> */}

      <Box id="section-specification">
        <MemoizedKeySpecifications
          keySpecifications={keySpecificationsInfo?.piaggioFXMax}
          headerInfo={KEY_SPECIFICATION_HEADER}
        />
      </Box>

      <Box id="section-summary">
        <HeaderDesc
          HeadingTag="h2"
          heading={HIGHLIGHTS_HEADING}
          subText={HIGHLIGHTS_DESCRIPTION}
        />
      </Box>

      <HeaderDesc HeadingTag="h2" heading={MOSTLY_BOUGHT_FOR_HEADING} />

      <VehicleSpecificUseSwiper
        slidePerView={4}
        data={useCaseData}
        isHeader={false}
        isTitle={false}
      />

      <VehicleSpecificUseSwiper
        slidePerView={4}
        data={noentryData}
        headerInfo={BUSINESS_BENEFIT_HEADING}
      />

      <MemoizedVehicleFeatures
        promisesData={vehiclePromiseList?.piaggioFXMax}
        headerInfo={FEATURES_HEADING}
      />

      <MemoizedBrandDealerNear
        BannerDealerData={{
          headerInfo: BRAND_DEALER_HEADING,
          description: BRAND_DEALER_DESCRIPITION,
          desktopImg: imagesWEBP?.locationBanner,
          mobileImg: imagesWEBP?.multibrandstore,
        }}
      />

      <PricingPopularCities
        vehicleBrand={brand}
        vehicleName={vehicleDataLocal?.[0]?.vehicle_name || vehicleDataLocal?.[0]?.name || "E-Xtra FX Max"}
        brand={brand}
        model={vehicleModel}
      />

      <Box
        sx={{
          width: "100vw",
          alignItems: "center",
          flexDirection: "column",
          paddingLeft: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
          paddingRight: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
          marginTop: "48px",
          paddingTop: "12px",
        }}
      >
        <TurnoPromiseComponent />
        <NewVehicleReview images={images} slidesPerView={isMobile ? 1.4 : 4} />
        <VehicleLatestList latestVehiclesInfo={latestVehiclesInfo} />

        <Box
          sx={{ padding: { xs: "10px", sm: "10px", md: "20px", lg: "20px" } }}
        >
          <FAQ
            faqList={vehicleFAQs?.piaggioFXMax}
            showItems={5}
            headText={FAQ_HEADING_TEXT}
          />
        </Box>

        <LoanFormPopupV2 />
        <Box
          sx={{
            width: { xs: "100%", md: "84%" },
            margin: "20px auto",
            padding: { xs: "0 12px", md: "0" },
          }}
        >
          <Breadcrumbs items={BREADCRUMB_ITEMS} />
        </Box>
      </Box>

      <MemoizedFooter />
      </Box>
    </>
  );
}

export const getStaticProps = (context) => {
  let vehicleData = [...vehicles, ...newVehicles];

  const brand = "Piaggio";
  const vehicleModel = "E-Xtra-FX-Max";

  let vehicleDataLocal = vehicleData?.filter(function (vehicle) {
    return vehicle?.vehicle_path_id === `${vehicleModel}`;
  });

  let latestVehiclesInfo = vehicleData?.filter((vehicle) => {
    return vehicle?.vehicle_path_id !== `${vehicleModel}`;
  });

  // Constants are already imported at the top of the file
  const { vehicleFAQs } = require("../../../../src/constants/brandFaqs");

  // Generate Product Schema
  const vehicleDataItem = vehicleDataLocal?.[0];
  const productImages = vehicleDataItem?.images_287 || [
    imagesWEBP?.piaggioFxMaxImage1,
    imagesWEBP?.piaggioFxMaxImage2,
    imagesWEBP?.piaggioFxMaxImage3,
    imagesWEBP?.piaggioFxMaxImage4,
  ].filter(Boolean);

  // Get price range from vehicle data
  const getPriceRange = () => {
    if (!vehicleDataItem?.prices) return { lowPrice: 390000, highPrice: 400000 };
    const allPrices = [];
    Object.values(vehicleDataItem.prices).forEach((statePrices) => {
      Object.values(statePrices).forEach((variant) => {
        if (variant.price) {
          allPrices.push(variant.price * 100000); // Convert lakhs to rupees
        }
      });
    });
    return {
      lowPrice: Math.min(...allPrices),
      highPrice: Math.max(...allPrices),
    };
  };

  const priceRange = getPriceRange();

  const productSchema = generateProductSchema({
    name: "Piaggio E-Xtra FX Max",
    description: HIGHLIGHTS_DESCRIPTION || META_CONTENT[0]?.content,
    image: productImages,
    url: VEHICLE_LINK,
    brand: createBrand({
      name: "Piaggio",
      url: "https://www.turno.club/electric-commercial-vehicles/Piaggio",
    }),
    category: "Electric Commercial Vehicle",
    model: "E-Xtra FX Max",
    manufacturer: {
      "@type": "Organization",
      name: "Piaggio Vehicles Private Limited",
    },
    offers: createOffer({
      offerCount: 4,
      lowPrice: priceRange.lowPrice,
      highPrice: priceRange.highPrice,
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      url: VEHICLE_LINK,
      seller: {
        "@type": "Organization",
        name: "Turno",
        url: "https://www.turno.club/",
      },
    }),
    additionalProperty: [
      vehicleDataItem?.load
        ? createPropertyValue({ name: "Load Capacity", value: vehicleDataItem.load })
        : null,
      vehicleDataItem?.range
        ? createPropertyValue({ name: "Range", value: vehicleDataItem.range })
        : null,
      vehicleDataItem?.batteryCapacity
        ? createPropertyValue({
            name: "Battery Capacity",
            value: vehicleDataItem.batteryCapacity,
          })
        : null,
      vehicleDataItem?.batteryVoltage
        ? createPropertyValue({
            name: "Battery Voltage",
            value: vehicleDataItem.batteryVoltage,
          })
        : null,
    ].filter(Boolean),
    keywords: META_CONTENT[1]?.content || "Piaggio E-Xtra FX Max, electric vehicle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    itemCondition: "https://schema.org/NewCondition",
    isFamilyFriendly: true,
    slogan: "High-capacity electric three-wheeler for cargo transportation",
  });

  // Generate FAQPage Schema
  const faqQuestions = convertFAQsToQuestions(vehicleFAQs?.piaggioFXMax || [], {
    url: VEHICLE_LINK,
    dateCreated: new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
    },
  });

  const faqPageSchema = generateFAQPageSchema({
    mainEntity: faqQuestions,
    name: FAQ_HEADING_TEXT || "FAQs on Piaggio E-Xtra FX Max",
    description: `Frequently asked questions about Piaggio E-Xtra FX Max electric commercial vehicle. ${HIGHLIGHTS_DESCRIPTION || ""}`,
    url: VEHICLE_LINK,
    headline: FAQ_HEADING_TEXT || "FAQs on Piaggio E-Xtra FX Max",
    keywords: META_CONTENT[1]?.content || "Piaggio E-Xtra FX Max, FAQ, electric vehicle",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
      logo: {
        "@type": "ImageObject",
        url: "https://www.turno.club/logoIcon.png",
      },
    },
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    breadcrumb: BREADCRUMB_SCHEMA,
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: productImages[0] || "https://www.turno.club/logoIcon.png",
    },
    isFamilyFriendly: true,
    isAccessibleForFree: true,
    speakable: {
      "@type": "SpeakableSpecification",
      xPath: [
        "/html/head/title",
        "/html/head/meta[@name='description']/@content",
      ],
    },
  });

  return {
    props: { 
      brand, 
      vehicleModel, 
      vehicleDataLocal, 
      latestVehiclesInfo,
      productSchema,
      faqPageSchema,
    },
  };
};
